import { Component, OnInit, ViewChild, AfterViewInit, TemplateRef } from '@angular/core';
import { ManagePackagesDataSource } from '../../../../core/packages/_data-sources/manage-packages.datasource';
import { MatPaginator, MatSort, MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { PackagesHttpService } from '../../../../core/packages';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditFileDialogComponent } from '../edit-file-dialog/edit-file-dialog.component';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-manage-package',
  templateUrl: './manage-package.component.html',
  styleUrls: ['./manage-package.component.css']
})
export class ManagePackageComponent implements OnInit, AfterViewInit {

	displayedColumns = ['file_version', 'file_desc', 'file_name', 'uploaded_at', 'actions'];

	dataSource: ManagePackagesDataSource;

	typeSelected: string | number | null = null;
	modeSelected: string | number | null = null;

	typeOptions: SelectOption[] = [
		{ value: 'ui', label: 'UI' },
		{ value: 'menu', label: 'Menu' },
		{ value: 'aux', label: 'VMC' }
	];
	modeOptions: SelectOption[] = [
		{ value: 'engg', label: 'Engineering Review' },
		{ value: 'curr', label: 'Current' },
		{ value: 'arch', label: 'Archived' }
	];

	private dialogConfig = new MatDialogConfig();

	qParams = {};

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	@ViewChild('successTemp', {static: true})
	private msgTempRef: TemplateRef<any>;

	types = [
		{text: 'UI', value: 'ui'},
		{text: 'Menu', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	typesA = [
		{text: 'UI', value: 'ui'},
		{text: 'Menu', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	modes = [
		{text: 'Engineering Review', value: 'engg'},
		{text: 'Current', value: 'curr'},
		{text: 'Archived', value: 'arch'}
	];

	availableColors = [
		{ name: 'v0.1.0', color: '' },
		{ name: 'v0.1.1', color: 'primary' },
		{ name: 'v0.1.2', color: 'accent' },
		{ name: 'v0.1.3', color: 'warn' }
	];

	availableVersions = [];

  constructor(private http: PackagesHttpService,
				public dialog: MatDialog,
				private modalService: NgbModal,
				private _snackBar: MatSnackBar,
				private mixpanelService: MixpanelService) { }

  ngOnInit() {
	  this.dataSource = new ManagePackagesDataSource(this.http);
	  this.qParams = {
		noPerPg: this.paginator.pageSize || 5,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: 'uploaded_at',
		sortVal: 'desc',
		optFilterKey: 'file_type',
		optFilterVal: '',
		txtFilterKey: 'file_mode',
		txtFilterVal: ''
	};

	  this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
  }

  ngAfterViewInit() {
	this.dataSource.counter$
	.pipe(
		tap((count) => {
		this.paginator.length = count;
		})
	)
	.subscribe();

	this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

	merge(this.paginator.page, this.sort.sortChange).pipe(
		tap(() => {
			this.loadPackageListPage();
		})
	)
	.subscribe();

  }


  deleteFile(component, file) {
	this.modalService.open(component, {size: 'sm'}).result.then((result) => {
		// console.log('result', result);
		if (result === 'delete') {
			this.http.cloudDelete(file)
			.subscribe(resp => {
				this.showSnackBar('Deleted Successfully', 0);
				this.loadPackageListPage();
				setTimeout(() => {
					this._snackBar.dismiss();
				}, 2000);
			}, error => {
				this.showSnackBar('Error while deleting', 0);
			});
		} else {
			// console.log('Simply closed');
		}
	}, (reason) => {
		// console.log(reason);
	});
  }

  editFile(component, file) {
	const dialogConfig = new MatDialogConfig();
	dialogConfig.autoFocus = true;

	dialogConfig.data = file;
	const dialogRef = this.dialog.open(EditFileDialogComponent, dialogConfig);
	dialogRef.afterClosed().subscribe(res => {
		if (!res) {
			return;
		} else {
			// console.log('returned:', res);
			if (res.success) {
				this.showSnackBar('Updated Successfully', 0);
				this.loadPackageListPage();
			} else {
				this.showSnackBar('Error while uploading', 0);
			}
		}
	});
	// this.modalService.open(component, {size: 'lg'}).result.then((result) => {
	// 	// console.log(result);
	// }, (reason) => {
	// 	// console.log(reason);
	// });
  }

  typeChanged(val: string | number | null) {
	this.typeSelected = val;
	if (val && this.modeSelected) {
		this.loadPackageListPage();
	}
  }

  modeChanged(val: string | number | null) {
	this.modeSelected = val;
	if (val && this.typeSelected) {
		this.loadPackageListPage();
	}
  }

  loadPackageListPage() {
	const typeValue = this.typeSelected || '';
	const modeValue = this.modeSelected || '';

	const params = {
		noPerPg: this.paginator.pageSize || 5,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		optFilterKey: 'file_type',
		optFilterVal: typeValue,
		txtFilterKey: 'file_mode',
		txtFilterVal: modeValue
	};
	// // console.log(params);

	this.dataSource.loadPackageList(params);
  }

  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

}
